import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "boxMessage" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_zapora absolute" }, null, -1)
const _hoisted_3 = { class: "eventCard" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "sensorGreen" }
const _hoisted_6 = { class: "when" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.feature.properties.cesta), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.feature.properties.opis), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.feature.properties.vzrok), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$moment(_ctx.feature.properties.updated).fromNow()), 1)
  ]))
}